import { Box } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { ScoutChatItem } from 'services/API/AIInteractionAPI';

const listStyle = {
  overflowY: 'auto' as const,
  flex: 1,
  minHeight: 0,
};

const listItemStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap' as const,
  padding: 'padding_4',
  borderRadius: '6px',
  cursor: 'pointer',
};

const emptyPlaceholderStyle = {
  paddingTop: 'padding_8',
};

type PreviousChatsListProps = {
  chats: ScoutChatItem[];
  selectedChatId?: string | null;
  onSelectChat?: (id: string, name: string) => void;
};

const PreviousChatsList = ({
  chats,
  selectedChatId,
  onSelectChat,
}: PreviousChatsListProps) => {
  return (
    <FlexColumn sx={listStyle}>
      <Text.SmallLabel color={Colors.TextQuiet}>PREVIOUS CHATS</Text.SmallLabel>
      {chats.length === 0 ? (
        <Text.Body sx={emptyPlaceholderStyle} color="brand.grey">
          No chats, yet...
        </Text.Body>
      ) : (
        <Box sx={{ marginTop: 'padding_4' }}>
          {chats.map((chat) => (
            <Box
              key={chat.session_id}
              sx={{
                ...listItemStyle,
                ...(chat.session_id === selectedChatId
                  ? { backgroundColor: Colors.ArmyGreen200 }
                  : {}),
              }}
              onClick={() => onSelectChat?.(chat.session_id, chat.display_name)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelectChat?.(chat.session_id, chat.display_name);
                }
              }}
              _hover={{ backgroundColor: Colors.ArmyGreen300 }}
            >
              <Text.Small title={chat.display_name}>{chat.display_name}</Text.Small>
            </Box>
          ))}
        </Box>
      )}
    </FlexColumn>
  );
};

export default PreviousChatsList;
